"use client";

import React, { useState, useEffect } from 'react';
import ChatbotWidget from './chatbotWidget';
import './chatbotWidget.scss';
import { PiChatTextFill } from "react-icons/pi";
import { studentProfile } from '../../../../../Api/apiUtils';
import { MixpanelEvents,trackEvent } from '../../../../../utils/mixpanelTracking';

const FloatingChatButtonIcon = () => (
    <svg className="h-7 w-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
    </svg>
);

export default function ChatbotLauncher({ studentId, credentialId, hideButton = false }) {
    const [isChatbotOpen, setIsChatbotOpen] = useState(false);
    const [autoStart, setAutoStart] = useState(false);
    const [profileData, setProfileData] = useState(null);

    const toggleChatbot = () => {
        setIsChatbotOpen((prev) => !prev);
        setAutoStart(true); // Enable auto-start when manually toggled
    };

    useEffect(() => {
        const fetchProfileData = async () => {
            setProfileData(await studentProfile(credentialId, studentId));
        };

        fetchProfileData();
    }, [credentialId, studentId]);

    return (
        <>
            {!hideButton && (
                <button
                    type="button"
                    onClick={toggleChatbot}
                    className="chatbot-launcher-fab"
                    aria-label="Open Chatbot"
                >
                    <PiChatTextFill size={30} aria-hidden="true" />
                </button>
            )}
            {isChatbotOpen && (
                <div className="chatbot-modal">
                    <ChatbotWidget
                        isVisible={isChatbotOpen}
                        onClose={() => setIsChatbotOpen(false)}
                        initialEmail=""
                        initialPhoneNumber={
                            profileData?.mobileNumber
                                ? `${profileData.countryCode}${profileData.mobileNumber}`
                                : ""
                        }
                        autoStart={autoStart}
                    />
                </div>
            )}
        </>
    );
}
